import { buildCssClassName } from "@/3514/utils"

type Props = {
    phase: string
    completed: boolean
}

export const SimulabStageIndicator = ({ phase, completed }: Props) => {
    return <div className={buildCssClassName("simulab-stage-indicator", { completed })}>{phase?.charAt(0)}</div>
}
